import styled from '@xstyled/styled-components';
import React, { ChangeEventHandler } from 'react';
import Icon from './star.svg';

const ActiveIcon = styled(Icon)`
  stroke: accentDark;
  fill: accentDark;
`;

/** Visually hidden but still keyboard-focusable (0×0 inputs are skipped by Tab). */
const HiddenRadio = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const Label = styled.label`
  display: inline-block;
  padding: xs;
  cursor: pointer;
  position: relative;

  &:focus-within {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
    border-radius: 4px;
    z-index: 1;
  }

  &:focus-within::after {
    content: '';
    display: block;
    position: absolute;
    border-radius: 4px;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border: 2px solid white;
    pointer-events: none;
  }
`;

interface Props {
  onChange: ChangeEventHandler<HTMLInputElement>;
  active: boolean;
  checked: boolean;
  value: number;
  name: string;
  ariaLabel: string;
}

export const Star = ({
  onChange,
  active,
  checked,
  value,
  name,
  ariaLabel
}: Props) => (
  <Label>
    <HiddenRadio
      type="radio"
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      aria-label={ariaLabel}
    />
    {active ? (
      <ActiveIcon aria-hidden="true" focusable="false" />
    ) : (
      <Icon aria-hidden="true" focusable="false" />
    )}
  </Label>
);
